export enum COMMUNITY_ADMIN {
    /**
     * @value Communities have been successfully deleted
     */
    DELETED_MULTIPLE = 'ADMIN.COMMUNITIES.DELETED_MULTIPLE',
    /**
     * @value Community successfully deleted
     */
    DELETED_ONE = 'ADMIN.COMMUNITIES.DELETED_ONE',
    /**
     * @value Delete communities
     */
    DELETE_MULTIPLE = 'ADMIN.COMMUNITIES.DELETE_MULTIPLE',
    /**
     * @value Delete %NB% Communities
     * @description Messages shown when trying to delete multiple communities with the number showing.
     *
     * Parameters:
     * - NB: number of communities to delete
     */
    DELETE_NB = 'ADMIN.COMMUNITIES.DELETE_NB',
    /**
     * @value <strong>%NB% Communities</strong> will be permanently deleted.
     * @description Message shown in the confirmation dialog when multiple communities are being deleted.
     *
     * Parameters:
     * - NB: number of communities to delete
     */
    DELETE_NB_DESCRIPTION = 'ADMIN.COMMUNITIES.DELETE_NB.DESCRIPTION',
    /**
     * @value Delete community
     */
    DELETE_ONE = 'ADMIN.COMMUNITIES.DELETE_ONE',
    /**
     * @value <strong>%TITLE%</strong> Community will be permanently deleted.
     * @description Message shown in a confirmation dialog when trying to delete a community.
     */
    DELETE_ONE_WITH_TITLE = 'ADMIN.COMMUNITIES.DELETE_ONE_WITH_TITLE',
    /**
     * @value New community
     * @description Button to create a new community
     */
    NEW_COMMUNITY = 'COMMUNITIES_ADMIN.NEW_COMMUNITY',
    /**
     * @value Create communities to give your users a voice.<br/>Allow them to share, collaborate and create ideas.
     * @description Message appearing when there are no communities in the admin communities page. It invites users to create a first community.
     */
    NO_COMMUNITIES_DESCRIPTION = 'ADMIN.COMMUNITIES.NO_COMMUNITIES_DESCRIPTION',
    /**
     * @value Save as template
     * @description Menu entry and tooltip text to save a community's settings as a template to create other communites
     */
    SAVE_AS_TEMPLATE = 'COMMUNITIES_ADMIN.SAVE_AS_TEMPLATE',
    /**
     * @value There are no communities.
     * @description Appears instead of a list of results during a community search when there are no results despite the fact that the user looked for any community.
     * The user didn't write anything in the search field so he is looking for any existing community but there are simply no communities at all.
     */
    SEARCH_NO_RESULTS = 'FRONT.COMMUNITY.SEARCH.NO_RESULTS',
    /**
     * @value Community templates
     */
    TEMPLATES = 'ADMIN.NAV.COMMUNITY_TEMPLATES',
}

enum SPACES_SPECIFIC_KEYS {
    /**
     * @value Spaces have been successfully deleted
     * @description The term "Space" must not be translated, it is a male name.
     */
    DELETED_MULTIPLE = 'SPACES.DELETED_MULTIPLE',
    /**
     * @value Space successfully deleted
     * @description Prompted when one space have been successfully deleted
     * The term "Space" must not be translated, it is a male name.
     */
    DELETED_ONE = 'SPACES.DELETED_ONE',
    /**
     * @value Delete spaces?
     * @description The term "space" must not be translated, it is a male name.
     */
    DELETE_MULTIPLE = 'SPACES.DELETE_MULTIPLE',
    /**
     * @value Delete spaces?
     * @description Messages shown when trying to delete multiple spaces with the number showing.
     *
     * Parameters:
     * - NB: number of communities to delete
     *
     * The term "space" must not be translated, it is a male name.
     *
     */
    DELETE_NB = 'SPACES.DELETE_NB',
    /**
     * @value Deleting spaces is irreversible. You will delete their entire configuration.
     * @description Message shown in the confirmation dialog when multiple spaces are being deleted.
     *
     * Parameters:
     * - NB: number of communities to delete
     *
     * The term "Space" must not be translated, it is a male name.
     */
    DELETE_NB_DESCRIPTION = 'SPACES.DELETE_NB.DESCRIPTION',
    /**
     * @value Delete space?
     * @description Deleting a space
     * The term "Space" must not be translated, it is a male name.
     *
     */
    DELETE_ONE = 'SPACES.DELETE_ONE',
    /**
     * @value Deleting the space <strong>%TITLE%</strong> is irreversible. You will delete the entire configuration.
     * @description Message shown in a confirmation dialog when trying to delete a space.
     * The term "space" must not be translated, it is a male name.
     */
    DELETE_ONE_WITH_TITLE = 'SPACES.DELETE_ONE_WITH_TITLE',
    /**
     * @value New space
     * @description Button to create a new space
     * The term "Space" must not be translated, it is a male name.
     */
    NEW_COMMUNITY = 'SPACES.NEW_SPACE',
    /**
     * @value Create spaces to give your users a voice.<br/>Allow them to share, collaborate and create ideas.
     * @description Message appearing when there are no spaces in the admin communities page. It invites users to create a first space.
     * The term "Space" must not be translated, it is a male name.
     */
    NO_COMMUNITIES_DESCRIPTION = 'SPACES.NO_SPACES_DESCRIPTION',
    /**
     * @value There are no spaces.
     * @description Appears instead of a list of results during a space search when there are no results despite the fact that the user looked for any space.
     * The user didn't write anything in the search field so he is looking for any existing space but there are simply no spaces at all.
     * The term "Space" must not be translated, it is a male name.
     *
     */
    SEARCH_NO_RESULTS = 'SPACES.SEARCH_NO_RESULTS',
}

/** Getting spaces translate keys from space specific and community keys */
export const SPACES_ADMIN = { ...COMMUNITY_ADMIN, ...SPACES_SPECIFIC_KEYS };
